<template>
    <div class="">
        <div id="error" v-bind:class="{show:haveErrors}" class="fade mx-auto my-3 overflow-hidden pt-1 col-11 px-4">
            <p class="din-demi mb-1 text-center text-danger text-red" v-for="(value, key, index) in errors" :key="index" v-html="value[index]"></p>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name:"ValidationErrors",
        mounted() {
            console.log('Component mounted.')
            console.log(this.errors)
        },
        data() {
          return {
            
          }
        },
        computed:{
          ...mapGetters([
              'errors',
          ]),
          haveErrors:function(){
            if(Object.keys(this.errors).length>0){
              window.scrollTo({top:100, behavior:'smooth'}); 
              return true;
            }
            return false;
          }
        },
        methods: {
        },
    }
</script>
